export enum ModalType {
  SUCCESS = 'SUCCESS',
  ALERT = 'ALERT',
  CONFIRM = 'CONFIRM',
  INFO = 'INFO',
  ACTION = 'ACTION',
}
